/* @ngInject */
const myPassword = () => {
  return {
    require: 'ngModel',
    restrict: 'E',
    scope: {
      label: '=myLabel',
      icon: '=myIcon',
      required: '=myRequired',
      disabled: '=myDisabled',
      model: '=ngModel',
      pattern: '=myPattern',
      maxlength: '=myMaxlength',
      minlength: '=myMinlength',
      confirmation: '=myConfirmation',
    },

    template: require('./myPassword.html'),

    /* @ngInject */
    controller: ($scope) => {

    },

    link: (scope, element, attrs, ctrl) => {

    },
  }
}

export default myPassword



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/myPassword.js